import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { notification } from "antd";
import { Routes } from "../../../../../AppRoutes";
import { ITCodeRequestService } from "../../../../../services/it-code-request/itCodeRequest.service";

export const useCreatePCR = () => {
  const queryClient = useQueryClient();
  const history = useHistory();

  const { mutate, ...restMutation } = useMutation({
    mutationFn: (body: any) => ITCodeRequestService.addITCodeRequest(body),
  });

  const createPCRRequest = (body: any, options?: { onSuccess?: (res: any) => void }) => {
    mutate(body, {
      onSuccess(res: any) {
        queryClient.invalidateQueries({ queryKey: ["code-process-requests"] });
        history.push(Routes.processCodeGrantedDetailPage.path.replace(":id", res.id));
        notification.success({
          message: "Thành công!",
          description: `Tạo yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(res);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: `Tạo yêu cầu thất bại.`,
        });
      },
    });
  };

  return { mutate, createPCRRequest, restMutation };
};
